import { useState } from 'react';
import CategoryCombobox from './CategoryCombobox.jsx';
import Button from './Button.jsx';

/**
 * Barre d'actions flottante affichée quand au moins une transaction est
 * sélectionnée (sélection par le logo, cf. TransactionList/TransactionRow).
 * Reste montée tant que la sélection n'est pas vide : la catégorie choisie
 * localement survit donc à une erreur serveur (conservée pour un nouvel essai).
 */
export default function BulkActionBar({
  count,
  totalOnPage,
  onSelectAll,
  onClear,
  onApply,
  isPending = false,
  error,
  categories,
}) {
  const [categoryId, setCategoryId] = useState(null);
  const allSelected = totalOnPage != null && count >= totalOnPage;

  function handleApply() {
    if (!categoryId || isPending) return;
    onApply?.(categoryId);
  }

  return (
    <div
      role="region"
      aria-label="Actions sur la sélection"
      className="fixed left-2 right-2 bottom-[calc(3.5rem+env(safe-area-inset-bottom))] z-30 lg:left-64 lg:right-0 lg:bottom-4 lg:flex lg:justify-center lg:px-4 pointer-events-none"
    >
      <div className="pointer-events-auto bg-white border border-slate-200 rounded-xl shadow-lg px-3 py-3 space-y-2 lg:w-full lg:max-w-2xl">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <span aria-live="polite" className="text-sm font-medium text-slate-800">
            {count} sélectionnée{count > 1 ? 's' : ''}
          </span>
          <div className="flex items-center gap-3 shrink-0">
            {!allSelected && onSelectAll && (
              <button
                type="button"
                onClick={onSelectAll}
                className="text-xs text-slate-600 hover:text-slate-900 underline underline-offset-2"
              >
                Tout sélectionner
              </button>
            )}
            <button
              type="button"
              onClick={onClear}
              className="text-xs text-slate-500 hover:text-slate-800"
            >
              Annuler
            </button>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex-1 min-w-0">
            <CategoryCombobox
              value={categoryId}
              onChange={setCategoryId}
              placeholder="Catégorie à attribuer"
              categories={categories}
              placement="top"
            />
          </div>
          <Button
            type="button"
            onClick={handleApply}
            disabled={!categoryId || isPending}
            loading={isPending}
            className="text-sm px-3 py-2 shrink-0"
          >
            Appliquer
          </Button>
        </div>
        {error && (
          <p role="alert" className="text-xs text-red-600">
            {error.message ?? 'Une erreur est survenue.'}
          </p>
        )}
      </div>
    </div>
  );
}
